import { createAction, createReducer } from "@reduxjs/toolkit";
import type { ProcessingState } from "@redux/state/shared-types";
import { toggleEnrollmentBalanceBypass } from "./toggle-enrollment-balance-bypass";

export const resetToggleEnrollmentBalanceBypass = createAction("admin/resetToggleEnrollmentBalanceBypass");

const initialState: ProcessingState = {
  processing: "idle",
};

export const toggleEnrollmentBalanceBypassReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(toggleEnrollmentBalanceBypass.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(toggleEnrollmentBalanceBypass.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(toggleEnrollmentBalanceBypass.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetToggleEnrollmentBalanceBypass, () => {
    return initialState;
  });
});
